/**
 * Expandables Module
 * Handles expand/collapse components
 */

export function initExpandables(): void {
  const expandables = document.querySelectorAll<HTMLElement>('.expandable');

  expandables.forEach(expandable => {
    const toggle = expandable.querySelector<HTMLButtonElement>('.btn-expand');
    const content = expandable.querySelector<HTMLElement>('.expandable__content');

    if (!toggle || !content) return;

    toggle.addEventListener('click', () => {
      const isExpanded = expandable.classList.contains('is-expanded');

      expandable.classList.toggle('is-expanded');
      toggle.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', String(!isExpanded));

      // Update button text
      const textSpan = toggle.querySelector('span');
      if (textSpan) {
        textSpan.textContent = isExpanded ? 'Mehr anzeigen' : 'Weniger anzeigen';
      }
    });
  });
}
